//JS LIBRARIES
global.Modal = require('bootstrap/js/dist/modal');
global.Collapse = require('bootstrap/js/dist/collapse');
global.Offcanvas = require('bootstrap/js/dist/offcanvas');
global.Carousel = require('bootstrap/js/dist/carousel');
const LazyLoad = require("vanilla-lazyload");
global.lazyLoad = new LazyLoad();
require('../../scripts-optimized/polyfills');
require('../../scripts/Tools/lazy-background-image');
require('../../scripts/Tools/webp-polyfill');

//JS
require('../../scripts-optimized/Whatsapp/main-critic');
require('../../scripts-optimized/MessageSOS/main-critic');
require('../../scripts-optimized/Cookies/main-critic');
require('../../scripts-optimized/Newsletter/main-critic');
require('../../scripts-optimized/Country/Popup/main-critic');
require('../../scripts-optimized/PopupSmarterClick/main-critic');
require('../../scripts-optimized/Header/Messages/main-critic');
require('../../scripts-optimized/Header/SearcherV2/main-critic');
require('../../scripts-optimized/Header/LeftMenu/main-critic');
require('../../scripts-optimized/Header/Login/main-critic');
require('../../scripts-optimized/Header/Cart/main-critic');
require('../../scripts-optimized/Header/OuterMenu/main-critic');
require('../../scripts-optimized/Header/Breadcrumb/main-critic');
require('../../scripts-optimized/LeftMenu/main-critic');
require('../../scripts-optimized/LeftMenuV2/main-critic');

require('../../scripts-optimized/Tools/Textarea/main-critic');
require('../../scripts-optimized/Tools/ScrollTopButton/main-critic');
require('../../scripts-optimized/Tools/PopupImageZoom/main-critic');
require('../../scripts-optimized/Wishlist/main-critic');

require('../../scripts-optimized/ProductList/Results/General/main-critic');
require('../../scripts-optimized/ProductList/Results/Reviews/main-critic');
require('../../scripts-optimized/ProductList/Results/Filters/main-critic');
require('../../scripts-optimized/ProductList/Results/Product/main-critic');

require('../../scripts-optimized/Footer/Contact/main-critic');
require('../../scripts-optimized/Footer/Newsletter/main-critic');
require('../../scripts-optimized/Footer/Social/main-critic');

//CSS
